export const LOADING                   = 'LOADING'
export const LOADED                    = 'LOADED'
export const CLOSE_MODAL               = 'CLOSE_MODAL'
export const SEND_MESSAGE              = 'SEND_MESSAGE'
export const SET_LEFT_MENU_VISIBILITY  = 'SET_LEFT_MENU_VISIBILITY'
export const SHOW_LEFT_MENU            = 'SHOW_LEFT_MENU'
export const HIDE_LEFT_MENU            = 'HIDE_LEFT_MENU'
export const OPEN_CONTACT_DIALOG       = 'OPEN_CONTACT_DIALOG'
export const SET_PRIVATE_COLLECTIONS   = 'SET_PRIVATE_COLLECTIONS'
export const SET_PUBLIC_COLLECTIONS    = 'SET_PUBLIC_COLLECTIONS'
export const SET_CATEGORIES            = 'SET_CATEGORIES'
export const SHOW_RECOVER_CART_DIALOG  = 'SHOW_RECOVER_CART_DIALOG'
export const CLOSE_RECOVER_CART_DIALOG = 'CLOSE_RECOVER_CART_DIALOG'